import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import httpClient from './index'
import url from './url'

class StyleService {
  private static get client() {
    return httpClient.instance
  }

  static getStyles<T>(
    orderGUID: string,
    config?: AxiosRequestConfig,
  ): Promise<T> {
    return this.client
      .get(url.getStyles(orderGUID), config)
      .then((response: AxiosResponse<T>) => response.data)
      .catch(error => {
        if (axios.isAxiosError(error) && error.response)
          throw new Error(`${error.response.status}`)
        else throw new Error('500')
      })
  }
}

export default StyleService
